import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const Badge = ({ badge, size = 'small', showTooltip = true }) => {
  const sizeClasses = {
    tiny: 'w-4 h-4',
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  const badgeClass = sizeClasses[size] || sizeClasses.small;
  const badgeId = `badge-${badge.id}`;

  const imageSrc = `${process.env.PUBLIC_URL}${badge.image}`;

  console.log('🎯 Badge component rendering:', {
    badgeName: badge.name,
    badgeImage: badge.image,
    fullImageSrc: imageSrc,
    publicUrl: process.env.PUBLIC_URL
  });

  return (
    <div className="inline-block">
      <img
        src={imageSrc}
        alt={badge.name}
        className={`${badgeClass} object-contain`}
        data-tooltip-id={showTooltip ? badgeId : undefined}
        data-tooltip-content={showTooltip ? (badge.tooltipDescription || badge.name) : undefined}
        onError={(e) => {
          console.error('❌ Failed to load badge image:', imageSrc);
          console.error('Badge details:', badge);
          e.target.style.display = 'none';
        }}
        onLoad={() => {
          console.log('✅ Badge image loaded successfully:', imageSrc);
        }}
      />
      {showTooltip && (
        <Tooltip id={badgeId} place="top" effect="solid" />
      )}
    </div>
  );
};

export default Badge;
